import { useState } from "react";
import WorkspaceShell from "@/components/WorkspaceShell";
import StudentPicker from "@/components/StudentPicker";
import StudentWorkspace from "@/components/StudentWorkspace";
import ExamCalendar from "@/features/ExamCalendar";
import { Users, CalendarDays } from "lucide-react";

export default function ParentPanel() {
  const [selected, setSelected] = useState(null);
  return (
    <WorkspaceShell
      subtitle="Veli"
      mainNav={[
        { id: "children", label: "Öğrencim", icon: Users },
        { id: "exams", label: "Sınav Takvimi", icon: CalendarDays },
      ]}
    >
      {(tab, main) =>
        main === "exams" ? (
          <ExamCalendar focusStudentId={selected?.id} />
        ) : (
        <>
          <div className="mb-5">
            <h1 className="font-display text-2xl sm:text-3xl font-extrabold tracking-tight text-slate-900">Öğrenci Takibi</h1>
            <p className="text-slate-500 text-sm mt-1">Öğrencinizin tüm gelişimini buradan görüntüleyin (salt okunur).</p>
          </div>
          <div className="grid grid-cols-1 lg:grid-cols-[300px_1fr] gap-5">
            <StudentPicker selected={selected} onSelect={setSelected} autoSelectSingle />
            <div>
              {selected ? (
                <StudentWorkspace studentId={selected.id} studentName={selected.name} track={selected.track} readOnly={true} tab={tab} />
              ) : (
                <div className="card-ta p-12 text-center text-slate-500">Görüntülemek için soldan öğrenci seçin.</div>
              )}
            </div>
          </div>
        </>
        )
      }
    </WorkspaceShell>
  );
}
